import React from 'react';
import AdminLayout from '../components/admin/AdminLayout';
import BillingOverview from '../components/admin/BillingOverview';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AdminBilling = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded?.usertype !== 'master') {
        navigate('/login');
      }
    } catch (err) {
      console.error('Invalid token', err);
      navigate('/login');
    }
  }, [navigate]);
  return (
    <AdminLayout>
        <h1 className="text-3xl font-bold mb-6">Billing & Plans</h1>
      <BillingOverview />
    </AdminLayout>
  );
};

export default AdminBilling;
